import { useState } from "react";

export type HandleKeyPressArgs = {
    key: string;
    keyCode: number
}

const toInputValue = (amount: number): string => Number.isFinite(amount) ? String(amount) : ''

export const useAmountInput = (value: number, submit: (amount: number) => void) => {
    const [isActive, setActive] = useState<boolean>(false)
    const [editedValue, setEditedValue] = useState<string>(() => toInputValue(value))

    const activate = () => {
        setEditedValue(toInputValue(value))
        setActive(true)
    }

    const handleSubmit = () => {
        const editedAmount = parseFloat(editedValue)

        if (!Number.isFinite(editedAmount)) {
            setEditedValue(toInputValue(value))
            return
        }

        submit(editedAmount)
    }

    const handleKeyPress = ({key, keyCode}: HandleKeyPressArgs) => {
        if (key === 'Enter' || keyCode === 13) {
            setActive(false)
            handleSubmit()
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditedValue(e.target.value)
    }

    const handleBlur = () => {
        setActive(false)
        handleSubmit()
    }


    return {
        isActive,
        inputValue: editedValue,
        displayValue: toInputValue(value),
        handleSubmit,
        disactivate: () => setActive(false),
        activate,
        handleKeyPress,
        handleBlur,
        handleChange
    }
}
